import { render, staticRenderFns } from "./DisagreementsDialog.vue?vue&type=template&id=e99ee35a&scoped=true"
import script from "./DisagreementsDialog.vue?vue&type=script&lang=ts"
export * from "./DisagreementsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99ee35a",
  null
  
)

export default component.exports